export default "__VITE_PUBLIC_ASSET__876aa5e1__"